import { SerializableError } from '@src-common/utils/SerializableError';

class InitialLoadError extends SerializableError('InitialLoadError' as const) {}

export { InitialLoadError };
